import { Box } from "@mui/material";
import { CircularProgress } from "@mui/material";

const LoaderScreen = () => {
  return (
    <Box
      sx={{
        height: "calc(100vh - 70px)",
        backgroundColor: "background.default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <CircularProgress enableTrackSlot size="3rem" aria-label="Loading…" />
    </Box>
  );
};
export default LoaderScreen;
